import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Stat } from "@/pages/owner/OwnerDashboard";
import { AdminListings, AdminUsers, AdminBookings, AdminExtras } from "@/pages/admin/AdminTabs";
import ReportTab from "@/pages/admin/ReportTab";
import SiteTab from "@/pages/admin/SiteTab";
import { api, eur } from "@/lib/api";

const TABS = [["listings", "Annunci"], ["users", "Utenti"], ["bookings", "Prenotazioni"], ["extras", "Servizi extra"], ["report", "Report & Note"], ["site", "Sito"]];

export default function AdminPanel() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "listings";
  const [stats, setStats] = useState(null);
  const loadStats = useCallback(() => api.get("/admin/stats").then((r) => setStats(r.data)), []);
  useEffect(() => { loadStats(); }, [loadStats]);
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 sm:py-12" data-testid="admin-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#FF6B00]">Amministrazione</p>
      <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0B192C]">Pannello HomeToB</h1>
      {stats && (
        <div className="mt-6 grid grid-cols-2 lg:grid-cols-5 gap-3">
          <Stat label="Utenti" value={stats.users} testid="admin-stat-users" />
          <Stat label="Annunci pubblicati" value={stats.listings.published} testid="admin-stat-published" />
          <Stat label="In revisione" value={stats.listings.review} accent testid="admin-stat-review" />
          <Stat label="Richieste in attesa" value={stats.bookings.pending} testid="admin-stat-pending" />
          <Stat label="Commissioni HomeToB" value={eur(stats.revenue.total)} accent testid="admin-stat-revenue" />
        </div>
      )}
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })} className="mt-8">
        <div className="overflow-x-auto no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0">
          <TabsList className="h-12 inline-flex rounded-full bg-white border border-slate-200 p-1">
            {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className="rounded-full h-10 px-4 whitespace-nowrap data-[state=active]:bg-[#142B5C] data-[state=active]:text-white" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
          </TabsList>
        </div>
        <TabsContent value="listings" className="mt-6"><AdminListings onChange={loadStats} /></TabsContent>
        <TabsContent value="users" className="mt-6"><AdminUsers /></TabsContent>
        <TabsContent value="bookings" className="mt-6"><AdminBookings /></TabsContent>
        <TabsContent value="extras" className="mt-6"><AdminExtras /></TabsContent>
        <TabsContent value="report" className="mt-6"><ReportTab /></TabsContent>
        <TabsContent value="site" className="mt-6"><SiteTab /></TabsContent>
      </Tabs>
    </div>
  );
}
